<div class="page-container">
  <app-configurable-grid
    headerTitle="Product Details"
    [config]="gridConfig">
  </app-configurable-grid>
</div>
